import './StatusBadge.scss';

export const StatusBadge = ({ status }: { status: string }) => {
  const normalizedStatus = status.toLowerCase();

  const statusObj: { [key: string]: string } = {
    active: 'Active',
    deprecated: 'Deprecated',
    inactive: 'Inactive',
  };

  return (
    <div className={`status-badge status-badge__${normalizedStatus}`}>
      {statusObj[normalizedStatus]}
    </div>
  );
};
